export enum EnumPages {
  LOGIN = "Login",
  NEW_ACCOUNT = "Auto-Cadastro",
  RECOVER = "Recuperar senha",
  HOME = "Home",
  CONSORTIUM = "Consórcio",
  BANK = "Banco",
  INSURANCE = "Seguros",
  REPORTS = "Relatórios",

  CONSORTIUM_SALES = "Vendas",
  CONSORTIUM_SALES_SALES_TABLE = "Tabela de Preços",
  CONSORTIUM_REPORTS = "Relatórios",
  CONSORTIUM_REPORTS_BIRTHDATE = "Aniversariantes",
  REPORTS_RECEIVABLES_RECONCILIATION = "Conciliação de Recebíveis",

  CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT = "Gestão de Carteira",
  CONSORTIUM_SALES_PANEL = "Painel de Vendas",
  CONSORTIUM_CREDIT_ANALISYS = "Análise de Crédito",
  CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT = "Pagamento de Contemplação",

  RELATIONSHIP_PANEL = "Painel de Relacionamento",
  BANK_BAD_DEBT = "Inadimplência",
  BANK_BAD_DEBT_READ = "Inadimplência",

  PORTAL_CONSORTIUM = "Portal Consórcio",


  CONSORTIUM_REPORTS_COMMISSIONS = "Comissões",

  SETTINGS = "Configurações",
  SETTINGS_MESSAGES = "Mensagens",
  SETTINGS_MESSAGES_CREATE = "Mensagens - Criar",
  SETTINGS_MESSAGES_UPDATE = "Mensagens - Alterar",
  SETTINGS_MESSAGES_FILTER = "Mensagens",
  SETTINGS_BANNERS = "Banners",
  SETTINGS_BANNERS_FILTER = "Banners",
  SETTINGS_BANNERS_CREATE = "Banners - Criar",
  SETTINGS_BANNERS_UPDATE = "Banners - Alterar",
  SETTINGS_USERS = "Usuários",
  SETTINGS_USERS_FILTER = "Usuários",
  SETTINGS_USERS_CREATE = "Usuários - Criar",
  SETTINGS_USERS_UPDATE = "Usuários - Alterar",
  SETTINGS_PROFILE = "Perfil de Acesso",
  SETTINGS_PROFILE_FILTER = "Perfil de Acesso",
  SETTINGS_PROFILE_CREATE = "Perfil de Acesso - Criar",
  SETTINGS_PROFILE_UPDATE = "Perfil de Acesso - Alterar",

  SETTINGS_PARAMETERS = "Parâmetros",
  SETTINGS_PARAMETERS_FILTER = "Parâmetros",
  SETTINGS_PARAMETER_UPDATE = "Parâmetros - Modificar",
  SETTINGS_CONSUMPTION_REPORT = "Relatórios de consumo",
  SETTINGS_CONSUMPTION_REPORT_FILTER = "Relatórios de consumo",
  DEALERS = "Concessionária",
  DEALERS_DEBT_SETTLEMENT = "Tratar Inadimplência",

  SETTINGS_AWARD_PROGRAM = "Programa de Relacionamento",
  SETTINGS_AWARD_PROGRAM_FILTER = "Programa de Relacionamento",
  SETTINGS_AWARD_PROGRAM_LOGS_IMPORT = "Programa de Relacionamento - Logs de Importação",

  SETTINGS_DEALERS = "Pontos de Venda",
  SETTINGS_DEALERS_CREATE = "Pontos de venda - Criar",
  SETTINGS_DEALERS_UPDATE = "Pontos de Venda - Alterar",
  SETTINGS_DEALERS_FILTER = "Pontos de Venda",

  SETTINGS_ECONOMICGROUPS = "Grupos Econômicos",
  SETTINGS_ECONOMICGROUPS_CREATE = "Grupos Econômicos - Criar",
  SETTINGS_ECONOMICGROUPS_UPDATE = "Grupos Econômicos - Alterar",
  SETTINGS_ECONOMICGROUPS_FILTER = "Grupos Econômicos",

}
